export const REFRESH_FILES = 'ac-data/REFRESH_FILES'
export const REFRESH_FILES_SUCCESS = 'ac-data/REFRESH_FILES/SUCCESS'
export const REFRESH_FILES_ERROR = 'ac-data/REFRESH_FILES/ERROR'
